import Articles from "./Articles";
import AuthBasicUsers from "./AuthBasicUsers";
import Bugs from "./Bugs";
import Campaigns from "./Campaigns";
import Clients from "./Clients";
import ClientAccounts from "./ClientAccounts";
import ClientImages from "./ClientImages";
import ClientLocations from "./ClientLocations";
import ClientPages from "./ClientPages";
import ExternalServices from "./ExternalServices";
import Jobs from "./Jobs";
import SearchResults from "./SearchResults";
import SiteLogs from "./SiteLogs";
import SocialProfiles from "./SocialProfiles";
import UrlPositions from "./UrlPositions";
import ClientAudits from "./ClientAudits"
import Quotes from "./Quotes"
import Users from "./Users"

export default {
  "Articles": Articles,
  "Auth-Basic-Users": AuthBasicUsers,
  "Bugs": Bugs,
  "Campaigns": Campaigns,
  "Clients": Clients,
  "Client-Accounts": ClientAccounts,
  "Client-Images": ClientImages,
  "Client-Locations": ClientLocations,
  "Client-Pages": ClientPages,
  "External-Services": ExternalServices,
  "Jobs": Jobs,
  "Search-Results": SearchResults,
  "Site-Logs": SiteLogs,
  "Social-Profiles": SocialProfiles,
  "Url-Positions": UrlPositions,
  "Client-Audits": ClientAudits,
  "Quotes": Quotes,
  "Users": Users
}



// WEBPACK FOOTER //
// ./src/modules/modules.js